import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  subQuestion: PropTypes.string.isRequired
};

function SubQuestion(props) {
  return (
    <h3 className="subquestion">{props.subQuestion}</h3>
  );
}

SubQuestion.propTypes = propTypes;

export default SubQuestion;



/** WEBPACK FOOTER **
 ** ./src/components/SubQuestion.js
 **/